import { fetchSameOrigin } from '../Utils';

function deleteCareRecipient(careRecipientId, caregiverRoleId) {
  return fetchSameOrigin(
    `/members/${careRecipientId}/caregivers/${caregiverRoleId}`, 
    'DELETE',
    { body: JSON.stringify({
    caregiver_id: caregiverRoleId,
    member_id: careRecipientId,
    })}
  )
  .then(r => r.json())
  .then(({ message })=> new Promise((resolve) => {
    if(message){
      console.log('no errors');
      resolve({
        message: message
      });
    }
  })
  .finally(() =>{
    window.location.reload()
  }));
}

export default deleteCareRecipient;
